import { render, staticRenderFns } from "./BaseError.vue?vue&type=template&id=fab99ca0&scoped=true&"
import script from "./BaseError.vue?vue&type=script&lang=js&"
export * from "./BaseError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab99ca0",
  null
  
)

export default component.exports